import { BUILDER_CURRENCIES } from "./currencies";

const currencyCodes = BUILDER_CURRENCIES.map(({ code }) => code).join("|");
const currencySymbols = [...new Set(
  BUILDER_CURRENCIES.map(({ symbol }) => symbol)
    .filter((symbol) => !/^[A-Za-z]+$/.test(symbol)),
)].sort((left, right) => right.length - left.length)
  .map((symbol) => symbol.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
  .join("|");
const currency = `(?:\\b(?:${currencyCodes})\\b|${currencySymbols})`;
const amount = "[+-]?(?:0|[1-9]\\d*)(?:\\.\\d+)?";
const currencyBeforeAmount = new RegExp(
  `(?<![\\w/])(${currency}[ \\t\\u00a0]*\\(?[ \\t\\u00a0]*)(${amount})(?!\\w|[.,/:-]\\w)`,
  "g",
);
const currencyAfterAmount = new RegExp(
  `(?<![\\w.,/+-])(${amount})([ \\t\\u00a0]+${currency})(?!\\w)`,
  "g",
);

function groupAmount(value: string): string {
  const [integer, fraction] = value.split(".");
  // Work on digits directly to preserve precision and trailing decimal zeroes.
  const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return fraction === undefined ? grouped : `${grouped}.${fraction}`;
}

/** Format only currency-marked amounts; leave dates and other numeric text intact. */
export function formatQuestionMoney(text: string): string {
  return text
    .replace(currencyBeforeAmount, (_, prefix: string, value: string) =>
      `${prefix}${groupAmount(value)}`,
    )
    .replace(currencyAfterAmount, (_, value: string, suffix: string) =>
      `${groupAmount(value)}${suffix}`,
    );
}
